module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/nature.63d97f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/nature.jpg
// module id = hq1u
// module chunks = 0